module.exports = __webpack_public_path__ + "img/local-11.94331f44.jpg";